/**
 * Helpers
 * ------
 * General purpose helper functions for component-wide use
 */

window.helpers = {
	numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},
	formatPrice(x) {
		return moneyFormat.replace('{{amount}}', window.helpers.numberWithCommas((x / 100).toFixed(2)));
	},
	// Google Analytics Event (using GTM)
	gaEvent(category, action, label) {
		if (typeof ga === 'function' && typeof ga.getAll === 'function') {
			let tracker = ga.getAll()[0];
			if (tracker) tracker.send('event', category, action, label.toString());
		}
	},
	// Get Query Variable out of the URL
	getQueryVariable(variable) {
		let query = window.location.search.substring(1);
		let vars = query.split("&");
		for (let i = 0; i < vars.length; i++) {
			let pair = vars[i].split("=");
			if (pair[0] === variable) { return pair[1]; }
		}
		return (false);
	},
	// Includes function that works in IE versions that do not support the .includes jquery function
	includes(container, value) {
		let returnValue = false;
		let pos = container.indexOf(value);
		if (pos >= 0) returnValue = true;
		return returnValue;
	},
	// Browser check
	browser() {
		// Return cached result if available, else get result then cache it.
		if (browser.prototype._cachedResult)
			return browser.prototype._cachedResult;

		// Opera 8.0+
		let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

		// Firefox 1.0+
		let isFirefox = typeof InstallTrigger !== 'undefined';

		// Safari 3.0+ "[object HTMLElementConstructor]"
		let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

		// Internet Explorer 6-11
		let isIE = /*@cc_on!@*/false || !!document.documentMode;

		// Edge 20+
		let isEdge = !isIE && !!window.StyleMedia;

		// Chrome 1+
		let isChrome = !!window.chrome && !!window.chrome.webstore;

		// Blink engine detection
		let isBlink = (isChrome || isOpera) && !!window.CSS;

		return browser.prototype._cachedResult =
			isOpera ? 'Opera' :
				isFirefox ? 'Firefox' :
					isSafari ? 'Safari' :
						isChrome ? 'Chrome' :
							isIE ? 'IE' :
								isEdge ? 'Edge' :
									isBlink ? 'Blink' :
										"Don't know";
	},
	// Query string parser
	getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	},
	algoliaHitUrl(item, state, index) {
		let url = window.algoliaShop + '/products/';
		let highlighted = item._highlightResult; // easier to read
		if (item.product_type === 'Holsters') {
			url += item.url; // a normal product link
			if (highlighted.hasOwnProperty('legacy_part_number')) {
				if (highlighted.legacy_part_number.matchLevel === 'full') { // algolia says this is the best match
					if (state.query === item.legacy_part_number) { // make sure the query was an exact match since model numbers appear in part numbers
						url += '?part-number=' + item.legacy_part_number; // we'll try to auto-load the configuration on the PDP
					}
				}
			}
		} else {
			url += item.handle; // a normal product link
			// the key we're looking for in normal products is buried in the metafield object
			if (highlighted.hasOwnProperty('meta')) {
				if (highlighted.meta.hasOwnProperty('safariland')) {
					if (highlighted.meta.safariland.hasOwnProperty('legacy_part_number')) {
						if (highlighted.meta.safariland.legacy_part_number[0].matchLevel === 'full') {
							// the actual part number is wrapped by the highlighter hooks, so strip them off to check against the query
							let partNumber = highlighted.meta.safariland.legacy_part_number[0].value
								.replace('__aa-highlight__', '')
								.replace('__/aa-highlight__', '')
								.replace('<mark>', '')
								.replace('</mark>', '');
							if (state.query === partNumber) {
								url += '?variant=' + item.objectID; // use shopify's normal method for showing a particular variant
							}
						}
					}
				}
			}
		}
		
		// Add Algolia query ID to hit URL
		const _url = new URL(url);
		let queryID = item.__queryID;
		if (!queryID && item.__autocomplete_queryID) {
			queryID = item.__autocomplete_queryID;
		}
		url += (_url.search) ? '&' : '?';
		url += 'queryID=' + queryID + '&objectID=' + item.objectID + '&queryIndex=' + index;

		return url;
	},
	getAlgoliaQueryIdFromCurrentUrl() {
		const url = new URL(window.location.href);
		const searchParams = url.searchParams;

		const queryID = searchParams.get('queryID');

		return queryID;
	},
	trapFocus(elementId, focusFirst = true) {
		const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
		const trap = document.querySelector(elementId); // select the trap by it's id
		const firstFocusableElement = trap.querySelectorAll(focusableElements)[0]; // get first element to be focused inside trap
		const focusableContent = trap.querySelectorAll(focusableElements);
		const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap

		document.addEventListener('keydown', function (e) {
			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) { // if shift key pressed for shift + tab combination
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus(); // add focus for the last focusable element
					e.preventDefault();
				}
			} else { // if tab key is pressed
				if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
					firstFocusableElement.focus(); // add focus for the first focusable element
					e.preventDefault();
				}
			}
		});
		if (focusFirst) {
			setTimeout(() => {
				firstFocusableElement.focus();
			}, 350);
		}
	}
};